import React, { Fragment } from 'react'
import MobileSidebar from './MobileSidebar'
import MobileMenu from './MobileMenu'
import Hamburger from './Hamburger'

export default function MobileNav(props) {
  return (
    <Fragment>
      <Hamburger onClick={props.handleSlide} />
      <MobileSidebar slide={props.slide} linkComponent={props.linkComponent} />
      <MobileMenu linkComponent={props.linkComponent} />
    </Fragment>
  )
}
